import _isEqual from "lodash/isEqual";
import _cloneDeep from "lodash/cloneDeep";
import {SetProperties} from "@/models/SetProperties";

export class MedicalCertificateParent {
  constructor() {
    this.list = []
  }

  add(item) {
    this.list.push(MedicalCertificate.build(item))
  }

  update(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, MedicalCertificate.build(item))
  }

  remove(item) {
    const index = this.list.findIndex(el => _isEqual(_cloneDeep(el), _cloneDeep(item)))
    index >=0 && this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  build(obj) {
    if (obj) {
      this.list = obj.map(el => MedicalCertificate.build(el))
    }
    return this
  }
}

export class MedicalCertificate extends SetProperties{
  constructor() {
    super()
    this.id = null
    this.application = null
    this.number = null
    this.series = null

    this.filesData = {}
  }

  getForAPI() {
    return {
      id: this.id,
      application: this.application,
      number: this.number,
      series: this.series,
    }
  }

  static build(obj) {
    const _this = new MedicalCertificate()
    if (obj) {
      _this.id = obj.id
      _this.application = obj.application
      _this.number = obj.number
      _this.series = obj.series
    }
    return _this
  }
}
